var util = require('js/lib/util');
var moment = require('js/lib/moment');

var helpMenuTemplate = require('html/templates/helpMenu')();
var settingsMenuTemplate = require('html/templates/settingsMenu')();

commonCtrl.$inject = ['$rootScope', '$scope', '$window', 'router', 'load', 'login', 'loadScript', 'storage'];

function commonCtrl($rootScope, $scope, $window, router, load, login, loadScript, storage) {


  $scope.router = router;
  $scope.page = router.page().replace(/\//g, '-');

  $scope.baseUrl = process.env.BASE_URL;

  $scope.helpMenuTemplate = helpMenuTemplate;
  $scope.settingsMenuTemplate = settingsMenuTemplate;

  $scope.values = util.values;

  $scope.closeModal = function () {
    $scope._modal && $scope._modal.close();
  };

  $scope.loadCommonData = function () {
    load.users();
    load.driverUsers();
    load.companies();
    load.settings();
  };

  load.getDowntime();

  $scope.handleDeviationsLink = function () {
    return $rootScope.settings && $rootScope.settings.customerSystemSettings && $rootScope.settings.customerSystemSettings.some(function (css) {
      return css.handleDevatiations;
    });
  };

  $scope.commonDataLoaded = function() {
    return $scope.companies && $scope.settings && true;
  };

  loadScript
    .load('https://cdn.headwayapp.co/widget.js')
    .then(function() {
      $window.Headway.init();
    });

  $scope.login = login.login.bind(null, $scope);
  $scope.forgotPasswordURL = function(username) {
    //var includingUsername = username ? '&userNameOrEmail=' + username : '';
    return process.env.AUTH_URL + '/auth/static/password/reset?appKey=plango';
  };

}

module.exports = commonCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controllers/commonCtrl.js
 ** module id = 125
 ** module chunks = 1
 **/